export default "__VITE_ASSET__378aa40b__"